import AntAlert, { AlertProps } from 'antd/lib/alert';

export const Alert = ({ ...props }: AlertProps) => <AntAlert {...props} />;
